module.exports = __webpack_public_path__ + "img/statistics.4d57cb82.png";